export const ROUND_WINNER_TAB_URL = "?tab=round-winner";
export const SEASON_WINNER_TAB_URL = "?tab=season-winner";
export const QUAD_ROUND_WINNER_TAB_URL = "?tab=quad-round-winner";
export const tabs = [ ROUND_WINNER_TAB_URL, SEASON_WINNER_TAB_URL, QUAD_ROUND_WINNER_TAB_URL ];
